<template>
  <v-card class="pa-8" rounded>
    <p class="h6 blue-grey--text text--darken-3 ma-0 pa-0 mb-6">
      {{ $t('routines.choose_how_to_create_your_routine') }}
    </p>
    <v-card-text class="ma-0 pa-0 d-flex justify-center">
      <div
        v-for="(type, index) in typeCards"
        :key="type.type"
        :class="[index === 0 ? 'mr-5' : 'ma-0']"
      >
        <OptionCard
          :data-testid="`createRoutine-selection-${type.type}`"
          :description="type.description"
          :icon="type.icon"
          :type="type.type"
          :title="type.title"
          :tourId="type.tourId"
          :buttonText="$t('common.create')"
          @click="$emit('selected', type.type)"
        />
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'

import OptionCard from '@/components/OptionCardForModal.vue'

export default {
  name: 'TypeSelectionStep',

  components: {
    OptionCard,
  },

  computed: {
    ...mapGetters(['organization']),

    typeCards() {
      return [
        {
          type: 'newRoutine',
          title: this.$t('routines.routine_from_scratch'),
          icon: 'mdi-plus',
          description: this.$t('routines.create_a_new_routine'),
          tourId: 'create_routine_newRoutine',
        },

        {
          type: 'newRoutineFromTemplate',
          title: this.$t('routines.routine_from_template'),
          icon: 'mdi-creation-outline',
          description: this.$t('routines.choose_a_routine_from_templates'),
          tourId: 'create_routine_newRoutineFromTemplate',
        },
      ]
    },
  },
}
</script>
